import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {LanguageContext} from '../../../../../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../../../../../layouts/theme/designSystem';
import {SUPPORTED_LANGUAGE_LEVELS} from '../../../../../../lib/constants';
import {ALL_LANGUAGES_LIST} from '../../../../../../lib/languagesListConst';
import {ApplicantLanguage} from '../../../../../../types/shared-recruiting-types';

interface Props {
  languages?: ApplicantLanguage[];
}
export const Languages = ({languages}: Props) => {
  const currentLanguage = useContext(LanguageContext);
  const {t} = useTranslation();

  if (!languages || languages.length === 0) {
    return;
  }

  const RenderLanguages = () => {
    if (languages?.length) {
      return languages.map((language) => {
        const languageName = ALL_LANGUAGES_LIST.find((lang) => lang.id === language.isoCode);
        const languageLevel = SUPPORTED_LANGUAGE_LEVELS.find((languageLevel) => languageLevel === language.proficiency);
        return (
          <Box
            display={'flex'}
            key={language.resourceId}
            bgcolor={orangeColors[5]}
            mr={2}
            mb={2}
            p={'4px 16px'}
          >
            <Grid item mr={1}>
              <Typography variant='body1'>{languageName?.label[currentLanguage]}</Typography>
            </Grid>
            <Grid item mr={1}>
              <Typography variant='body1'>{`(${languageLevel || '--'})`}</Typography>
            </Grid>
          </Box>
        );
      });
    } else {
      return (
        <Typography variant='body1' fontStyle={'italic'}>
          {t('companyApplicants.applicantsCard.cardDetails.emptyState.noLanguages')}
        </Typography>
      );
    }
  };

  return (
    <Grid container direction='column'>
      <Grid item mb={1}>
        <Typography variant='h3'>{t('companyApplicants.applicantsCard.cardDetails.languages')}</Typography>
      </Grid>
      <Grid container direction='row'>
        <RenderLanguages />
      </Grid>
    </Grid>
  );
};
